/*
 * Coff Masthead theme scripts.
 * Progressive enhancement only: every form works without JavaScript.
 */
(function () {
  'use strict';

  /**
   * Variant picker: keeps price, availability, the add button, and the URL
   * in sync with the selected variant. Data comes from a JSON script that
   * Liquid renders from the real product variants.
   */
  function initVariantPicker(section) {
    var select = section.querySelector('[data-variant-select]');
    var dataEl = section.querySelector('[data-variant-json]');
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (error) {
      return;
    }

    var price = section.querySelector('[data-price]');
    var compare = section.querySelector('[data-compare-price]');
    var compareValue = section.querySelector('[data-compare-price-value]');
    var availability = section.querySelector('[data-availability]');
    var button = section.querySelector('[data-add-button]');
    var buttonLabel = section.querySelector('[data-add-label]');
    var sellingPlan = section.querySelector('[data-selling-plan-select]');

    function updateSellingPlan(variant) {
      if (!sellingPlan || !variant) return;
      var options = sellingPlan.options;
      for (var i = 0; i < options.length; i++) {
        var option = options[i];
        if (option.value === '') {
          option.textContent = 'One-time purchase — ' + variant.price;
          option.dataset.planPrice = variant.price;
          continue;
        }
        var matches = String(option.dataset.planVariant) === String(variant.id);
        option.hidden = !matches;
        option.disabled = !matches;
      }
      var current = sellingPlan.selectedOptions[0];
      if (!current || current.disabled) sellingPlan.value = '';
      if ((!sellingPlan.selectedOptions[0] || sellingPlan.selectedOptions[0].disabled) && sellingPlan.options.length) {
        for (var j = 0; j < sellingPlan.options.length; j++) {
          if (!sellingPlan.options[j].disabled) { sellingPlan.selectedIndex = j; break; }
        }
      }
    }

    function selectedPrice(variant) {
      var option = sellingPlan && sellingPlan.selectedOptions[0];
      return option && option.value ? option.dataset.planPrice : variant.price;
    }
    var text = section.dataset;

    function findVariant(id) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return null;
    }

    function update() {
      var variant = findVariant(select ? select.value : variants[0] && variants[0].id);

      if (!variant) {
        if (availability) availability.textContent = text.textUnavailable;
        if (button) {
          button.disabled = true;
          if (buttonLabel) buttonLabel.textContent = text.textUnavailable;
        }
        return;
      }

      updateSellingPlan(variant);
      if (price) price.textContent = selectedPrice(variant);

      if (compare && compareValue) {
        var chosenPlan = sellingPlan && sellingPlan.selectedOptions[0] && sellingPlan.selectedOptions[0].value;
        var referencePrice = chosenPlan ? variant.price : variant.compare;
        if (referencePrice && referencePrice !== selectedPrice(variant)) {
          compareValue.textContent = referencePrice;
          compare.hidden = false;
        } else {
          compareValue.textContent = '';
          compare.hidden = true;
        }
      }

      if (availability) {
        availability.textContent = variant.available ? text.textAvailable : text.textSoldOut;
      }

      if (button) {
        button.disabled = !variant.available;
        if (buttonLabel) buttonLabel.textContent = variant.available ? text.textAdd : text.textSoldOut;
      }

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    if (select) select.addEventListener('change', update);
    if (sellingPlan) sellingPlan.addEventListener('change', update);
    updateSellingPlan(findVariant(select ? select.value : variants[0] && variants[0].id));
  }

  /**
   * Moves focus to form status messages (contact success/errors, password
   * errors) after a page reload so screen reader users hear the outcome.
   */
  function focusStatusMessage() {
    var message = document.querySelector('[data-focus-on-load]');
    if (!message) return;
    message.focus();
    if (typeof message.scrollIntoView === 'function') {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      message.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
    }
  }

  /**
   * Prevents a double submit on native forms that post to Shopify.
   */
  function guardDoubleSubmit() {
    var forms = document.querySelectorAll('.c-product__form, .c-cart__form');
    Array.prototype.forEach.call(forms, function (form) {
      form.addEventListener('submit', function (event) {
        if (form.dataset.submitting === 'true') {
          event.preventDefault();
          return;
        }
        form.dataset.submitting = 'true';
        form.setAttribute('aria-busy', 'true');
      });
    });

    // Reset if the page is restored from the back/forward cache.
    window.addEventListener('pageshow', function () {
      Array.prototype.forEach.call(forms, function (form) {
        delete form.dataset.submitting;
        form.removeAttribute('aria-busy');
      });
    });
  }

  function init() {
    var sections = document.querySelectorAll('[data-product-section]');
    Array.prototype.forEach.call(sections, initVariantPicker);
    focusStatusMessage();
    guardDoubleSubmit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialise sections when they change in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-product-section]');
    if (section) initVariantPicker(section);
  });
})();
